import { Modal, ModalHeader, Stack, ModalBody, useToast } from '@workramp/ui';
import { useEffect, useRef } from 'react';
import { HubspotUpsellFormWrapper, Description } from './HubspotUpsellModal.styles';

interface HubspotUpsellModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description: string;
  bullets?: string[];
  onSubmit?: () => void;
  inProductDemoConversionPage: string;
  hubspotFormId?: string;
  prefill?: boolean;
}

const HUBSPOT_REGION = 'na1';
const HUBSPOT_PORTAL_ID = '2349521';
const DEFAULT_HUBSPOT_FORM_ID = '9e98660d-7f85-4b0e-be61-95761ba006e3';

export const HubspotUpsellModal = ({
  isOpen,
  onClose,
  title,
  description,
  bullets,
  onSubmit,
  inProductDemoConversionPage,
  hubspotFormId,
  prefill = false,
}: HubspotUpsellModalProps) => {
  const formRef = useRef(null);
  const { open: openToast } = useToast();

  const successToastMsg = 'Your account executive will reach out to share more information!';

  useEffect(() => {
    const embedScriptTag = document.createElement('script');
    const script = document.createElement('script');
    embedScriptTag.src = '//js.hsforms.net/forms/embed/v2.js';
    script.src = 'https://js.hsforms.net/forms/shell.js';
    document.body.appendChild(embedScriptTag);
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      const { hbspt } = window;
      if (hbspt && formRef.current) {
        hbspt.forms.create({
          region: HUBSPOT_REGION,
          portalId: HUBSPOT_PORTAL_ID,
          formId: hubspotFormId || DEFAULT_HUBSPOT_FORM_ID,
          target: `#${formRef.current.id}`,
          onFormReady: ($form) => {
            const hiddenInputField = document.querySelector(
              'input[name="in_product_demo_conversion_page"]',
            ) as HTMLInputElement;
            hiddenInputField.value = inProductDemoConversionPage;

            if (prefill) {
              const [firstName, lastName] = window.getCurrentUser().name.split(' ');
              $form.find('input[name="email"]').val(window.getCurrentUser().email).change();
              $form.find('input[name="firstname"]').val(firstName).change();
              $form.find('input[name="lastname"]').val(lastName).change();
            }
          },
          onFormSubmit: () => {
            if (onSubmit) {
              setTimeout(() => {
                onSubmit();
              }, 500);
              return;
            }
            onClose();
            openToast({ children: successToastMsg });
          },
        });
      }
    });
    return () => {
      document.body.removeChild(script);
      document.body.removeChild(embedScriptTag);
    };
  }, [onClose, onSubmit, openToast, inProductDemoConversionPage, successToastMsg, hubspotFormId, prefill]);
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Stack size={1}>
        <ModalHeader title={title} />
        <ModalBody>
          {description && <Description>{description}</Description>}
          {bullets?.map((bullet) => (
            <ul key={bullet}>
              <li>{bullet}</li>
            </ul>
          ))}
          <HubspotUpsellFormWrapper>
            <div id="hubspotForm" data-testId="hubspot-upsell-modal" ref={formRef} />
          </HubspotUpsellFormWrapper>
        </ModalBody>
      </Stack>
    </Modal>
  );
};
